(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAboutHero(root) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var scroll = root.querySelector('.zk-abouthero__scroll');
      if (!scroll) return;
      scroll.addEventListener('click', function () {
        var section = root.closest('.shopify-section') || root;
        var target = section.nextElementSibling;
        if (target) {
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        } else {
          window.scrollBy({ top: window.innerHeight, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
    }
    document.querySelectorAll('.zk-abouthero').forEach(initAboutHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-manifesto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.Shopify && Shopify.designMode) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    /* Photos sharing a row reveal left to right, 120ms apart (offsetTop/Left ignore the transform) */
    function staggerRows(items) {
      var rows = {};
      items.forEach(function (el) {
        if (!el.offsetParent) return;
        (rows[el.offsetTop] = rows[el.offsetTop] || []).push(el);
      });
      Object.keys(rows).forEach(function (top) {
        rows[top].sort(function (a, b) { return a.offsetLeft - b.offsetLeft; })
          .forEach(function (el, i) { el.style.setProperty('--zk-reveal-delay', (i * 0.12) + 's'); });
      });
    }

    document.querySelectorAll('[data-zk-manifesto]').forEach(function (root) {
      var tiles = Array.prototype.slice.call(root.querySelectorAll('.zk-manifesto__tile'));
      if (!tiles.length) return;
      root.classList.add('is-reveal-armed');
      var restagger = function () { staggerRows(tiles); };
      restagger();
      window.addEventListener('resize', restagger);
      /* The observed zone is everything above the middle of the viewport (-50% bottom, unbounded
         top), so a tile is shown while its top is above mid-screen, even after it scrolls off the
         top, and fades back out when scrolling up drops it below the line, however fast. */
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          e.target.classList.toggle('is-revealed', e.isIntersecting);
        });
      }, { rootMargin: '100000px 0px -50% 0px' });
      tiles.forEach(function (t) { io.observe(t); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-stores"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.zk-aboutstores').forEach(function (root) {
      var stores = Array.prototype.slice.call(root.querySelectorAll('.zk-aboutstores__store'));
      var bgs = Array.prototype.slice.call(root.querySelectorAll('.zk-aboutstores__bg'));
      if (stores.length === 0) return;
      var mobileMq = window.matchMedia('(max-width: 749px)');

      /* The last hovered / focused / tapped (or, on mobile, scrolled-to) store stays active */
      function setActive(i) {
        stores.forEach(function (s, idx) {
          var on = idx === i;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        bgs.forEach(function (b, idx) { b.classList.toggle('is-active', idx === i); });
      }

      /* Mobile: the store crossing the middle of the viewport becomes active as the list scrolls */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!mobileMq.matches) return;
          entries.forEach(function (e) {
            if (e.isIntersecting) setActive(stores.indexOf(e.target));
          });
        }, { rootMargin: '-50% 0px -50% 0px' });
        stores.forEach(function (s) { io.observe(s); });
      }

      stores.forEach(function (s, idx) {
        var activate = function () { setActive(idx); };
        s.addEventListener('mouseenter', activate);
        s.addEventListener('focusin', activate);
        s.addEventListener('click', activate);
        s.addEventListener('keydown', function (e) {
          if (e.target !== s) return;
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
        });
      });

      setActive(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-team"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTeam(root) {
      var btn = root.querySelector('[data-team-more]');
      if (!btn) return;
      var grid = root.querySelector('[data-team-grid]');
      btn.addEventListener('click', function () {
        var hidden = grid.querySelectorAll('.zk-team__card.is-hidden');
        if (!hidden.length) return;
        hidden.forEach(function (card) { card.classList.remove('is-hidden'); });
        btn.classList.add('is-done');
      });
    }
    document.querySelectorAll('.zk-team').forEach(initTeam);

    document.querySelectorAll('.zk-team').forEach(function (root) {
      var track = root.querySelector('[data-team-grid]');
      var shell = root.querySelector('.zk-team__track-shell');
      if (!track || !shell) return;
      var mq = window.matchMedia('(max-width: 749px)');
      function updateFades() {
        if (!mq.matches) {
          shell.classList.remove('has-left-fade', 'has-right-fade');
          return;
        }
        var hasLeft = track.scrollLeft > 1;
        var hasRight = track.scrollLeft + track.clientWidth < track.scrollWidth - 1;
        shell.classList.toggle('has-left-fade', hasLeft);
        shell.classList.toggle('has-right-fade', hasRight);
      }
      track.addEventListener('scroll', updateFades, { passive: true });
      window.addEventListener('resize', updateFades);
      if (mq.addEventListener) mq.addEventListener('change', updateFades);
      updateFades();

      var moved = false;
      var start = null;
      function closeCards() {
        track.querySelectorAll('.zk-team__card.is-open').forEach(function (card) {
          card.classList.remove('is-open');
        });
      }
      track.addEventListener('pointerdown', function (e) {
        if (!mq.matches) return;
        moved = false;
        start = { x: e.clientX, y: e.clientY };
      });
      track.addEventListener('pointermove', function (e) {
        if (!start) return;
        if (Math.abs(e.clientX - start.x) > 10 || Math.abs(e.clientY - start.y) > 10) moved = true;
      });
      track.addEventListener('click', function (e) {
        if (!mq.matches || moved) return;
        var card = e.target.closest('[data-team-card]');
        if (!card || !track.contains(card)) return;
        var open = card.classList.contains('is-open');
        closeCards();
        if (!open) card.classList.add('is-open');
      });
      document.addEventListener('click', function (e) {
        if (!mq.matches || track.contains(e.target)) return;
        closeCards();
      });
    });

    /* Scroll reveal; the CSS only applies it to the ≥1200 grid. The observed zone is everything
       above a line 72px up from the bottom of the viewport (unbounded top), so a card appears once
       its top reaches that line and fades back when scrolling up drops it below. */
    if (window.Shopify && Shopify.designMode) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    /* Cards sharing a row reveal left to right, 120ms apart (offsetTop/Left ignore the transform) */
    function staggerRows(items) {
      var rows = {};
      items.forEach(function (el) {
        if (!el.offsetParent) return;
        (rows[el.offsetTop] = rows[el.offsetTop] || []).push(el);
      });
      Object.keys(rows).forEach(function (top) {
        rows[top].sort(function (a, b) { return a.offsetLeft - b.offsetLeft; })
          .forEach(function (el, i) { el.style.setProperty('--zk-reveal-delay', (i * 0.12) + 's'); });
      });
    }

    document.querySelectorAll('.zk-team').forEach(function (root) {
      var cards = Array.prototype.slice.call(root.querySelectorAll('.zk-team__card'));
      if (!cards.length) return;
      root.classList.add('is-reveal-armed');
      var restagger = function () { staggerRows(cards); };
      restagger();
      window.addEventListener('resize', restagger);
      var more = root.querySelector('[data-team-more]');
      if (more) more.addEventListener('click', function () { setTimeout(restagger); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          e.target.classList.toggle('is-revealed', e.isIntersecting);
        });
      }, { rootMargin: '100000px 0px -72px 0px' });
      cards.forEach(function (c) { io.observe(c); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRelated(root) {
      var track = root.querySelector('[data-related-track]');
      if (!track) return;
      var prev = root.querySelector('[data-dir="prev"]');
      var next = root.querySelector('[data-dir="next"]');

      function positions() {
        var cards = track.querySelectorAll('.zk-blog-card');
        var base = cards.length ? cards[0].offsetLeft : 0;
        return Array.prototype.map.call(cards, function (c) { return c.offsetLeft - base; });
      }
      function update() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= max;
      }
      // Scroll to the next/previous card's own snap position (not scrollLeft ± width),
      // remembering the target so rapid clicks chain cleanly instead of fighting the snap.
      var target = null, settle;
      function go(dir) {
        var from = target === null ? track.scrollLeft : target;
        var max = Math.max(track.scrollWidth - track.clientWidth, 0);
        var pos = positions(), to = null, i;
        if (dir > 0) { for (i = 0; i < pos.length; i++) { if (pos[i] > from + 1) { to = pos[i]; break; } } }
        else { for (i = pos.length - 1; i >= 0; i--) { if (pos[i] < from - 1) { to = pos[i]; break; } } }
        if (to === null) to = dir > 0 ? max : 0;
        target = Math.min(Math.max(to, 0), max);
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () {
        update();
        clearTimeout(settle);
        settle = setTimeout(function () { target = null; }, 150);
      }, { passive: true });
      update();

      // Mouse drag-to-scroll. Touch/pen are left to the browser: native panning already
      // snaps and has inertia, and running both at once made the drag stutter.
      var down = false, startX = 0, startLeft = 0, moved = false, pending = null, raf = 0;
      function applyDrag() { raf = 0; if (pending !== null) { track.scrollLeft = pending; pending = null; } }
      // Cards are links with images: native drag-and-drop would hijack the gesture mid-drag.
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; target = null;
        startX = e.clientX; startLeft = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4 && !moved) { moved = true; track.classList.add('is-dragging'); track.setPointerCapture(e.pointerId); }
        if (!moved) return;
        pending = startLeft - dx;                 // one scroll write per frame, not per pointermove
        if (!raf) raf = requestAnimationFrame(applyDrag);
      });
      function end() {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
        update();
      }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); } }, true);
    }
    document.querySelectorAll('.zk-related').forEach(initRelated);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nav = document.querySelector('[data-zk-colnav]');
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = '1';
    var list = nav.querySelector('[data-zk-colnav-list]');
    var slot = nav.closest('[data-zk-colnav-slot]');
    function liveSections() {
      return Array.prototype.filter.call(document.querySelectorAll('[data-zk-col-section]'), function (section) {
        return section.id && !section.hidden && section.getAttribute('data-zk-col-label');
      });
    }
    var sections = liveSections();
    if (sections.length < 2) return;
    sections.forEach(function (section) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + section.id;
      link.textContent = section.getAttribute('data-zk-col-label');
      item.appendChild(link);
      list.appendChild(item);
    });
    var links = list.querySelectorAll('a');
    var mark = document.createElement('span');
    mark.className = 'zk-colnav__mark';
    mark.setAttribute('aria-hidden', 'true');
    list.appendChild(mark);
    function headerHeight() {
      var header = document.querySelector('.zk-header');
      return header ? header.offsetHeight : 80;
    }
    function moveMark(link) {
      var item = link.parentElement;
      mark.style.width = item.offsetWidth + 'px';
      mark.style.transform = 'translateX(' + item.offsetLeft + 'px)';
    }
    function setActive(id) {
      var active = null;
      links.forEach(function (link) {
        var on = link.getAttribute('href') === '#' + id;
        link.classList.toggle('is-active', on);
        if (on) {
          link.setAttribute('aria-current', 'location');
          active = link;
        } else {
          link.removeAttribute('aria-current');
        }
      });
      if (active) moveMark(active);
    }
    function sectionInView() {
      var current = liveSections();
      var line = headerHeight() + nav.offsetHeight + 24;
      var id = current[0] ? current[0].id : '';
      current.forEach(function (section) {
        if (section.getBoundingClientRect().top <= line) id = section.id;
      });
      return id;
    }
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href').slice(1);
        var section = document.getElementById(id);
        if (!section) return;
        event.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        section.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.pushState) history.pushState(null, '', '#' + id);
      });
    });
    var frame = 0;
    function place() {
      var top = headerHeight();
      nav.style.setProperty('--zk-colnav-top', top + 'px');
      if (slot) slot.style.minHeight = nav.offsetHeight + 'px';
      var origin = slot ? slot.getBoundingClientRect().top + window.scrollY : 0;
      nav.classList.toggle('is-stuck', window.scrollY + top >= origin - 1);
      setActive(sectionInView());
    }
    window.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () { frame = 0; place(); });
    }, { passive: true });
    window.addEventListener('resize', place);
    place();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-banner"]) return;
  try {
    
  (function () {
    function init(root) {
      var KEY = 'zk-cookie-consent';
      var choice = null;
      try { choice = localStorage.getItem(KEY); } catch (e) {}
      if (choice) { return; }

      root.hidden = false;

      function api() {
        return window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
      }
      function decide(granted) {
        try { localStorage.setItem(KEY, granted ? 'accepted' : 'declined'); } catch (e) {}
        var cp = api();
        if (cp && cp.setTrackingConsent) {
          try {
            cp.setTrackingConsent(
              { analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted },
              function () {}
            );
          } catch (e) {}
        }
        // Animate out, then remove from layout.
        root.classList.add('is-closing');
        setTimeout(function () { root.hidden = true; root.classList.remove('is-closing'); }, 260);
      }
      var accept = root.querySelector('[data-zk-accept]');
      var decline = root.querySelector('[data-zk-decline]');
      if (accept) { accept.addEventListener('click', function () { decide(true); }); }
      if (decline) { decline.addEventListener('click', function () { decide(false); }); }
    }
    document.querySelectorAll('[data-zk-cookie]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    const footer = document.querySelector('[data-zk-footer]');
    if (!footer) return;
    footer.classList.add('zk-footer--js');

    const cols = Array.from(footer.querySelectorAll('[data-zk-footer-col]'));
    const desktop = window.matchMedia('(min-width: 1200px)');

    function setOpen(col, open) {
      col.classList.toggle('is-open', open);
      const toggle = col.querySelector('[data-zk-footer-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    // On desktop every column is always expanded and the heading is not a control.
    function syncBreakpoint() {
      cols.forEach(function (col) {
        const toggle = col.querySelector('[data-zk-footer-toggle]');
        if (!toggle) return;
        if (desktop.matches) {
          toggle.setAttribute('aria-expanded', 'true');
          toggle.setAttribute('tabindex', '-1');
        } else {
          toggle.removeAttribute('tabindex');
          toggle.setAttribute('aria-expanded', col.classList.contains('is-open') ? 'true' : 'false');
        }
      });
    }

    cols.forEach(function (col) {
      const toggle = col.querySelector('[data-zk-footer-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        if (desktop.matches) return;
        setOpen(col, !col.classList.contains('is-open'));
      });
    });

    if (desktop.addEventListener) desktop.addEventListener('change', syncBreakpoint);
    else desktop.addListener(syncBreakpoint);
    syncBreakpoint();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founders-letter"]) return;
  try {
    
  (function () {
    function bindLightbox() {
      var dialog = document.querySelector('[data-letter-lightbox-dialog]');
      if (!dialog || dialog.dataset.ready) return;
      dialog.dataset.ready = '1';
      var img = dialog.querySelector('img');
      document.addEventListener('click', function (event) {
        var link = event.target.closest('[data-letter-lightbox]');
        if (!link) return;
        event.preventDefault();
        if (img.getAttribute('src') !== link.href) img.setAttribute('src', link.href);
        img.alt = link.getAttribute('aria-label') || '';
        if (!dialog.open) dialog.showModal();
      });
      dialog.querySelector('[data-letter-lightbox-close]').addEventListener('click', function () {
        dialog.close();
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindLightbox);
    else bindLightbox();
  })();

  document.querySelectorAll('.zk-letter [data-gallery]').forEach(function (g) {
    function start() { if (window.zkGallery) window.zkGallery(g); }
    if (window.zkGallery) start();
    else document.addEventListener('DOMContentLoaded', start);
  });

  function letterNav() {
    var nav = document.querySelector('[data-letter-nav]');
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = '1';
    var list = nav.querySelector('[data-letter-nav-list]');
    var heads = Array.prototype.slice.call(document.querySelectorAll('.zk-letter__content h2, .zk-stores__title'));
    if (heads.length < 2) return;
    heads.forEach(function (heading, index) {
      if (!heading.id) heading.id = 'letter-section-' + index;
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.replace(/\s+/g, ' ').trim();
      item.appendChild(link);
      list.appendChild(item);
    });
    var links = list.querySelectorAll('a');
    var mark = document.createElement('span');
    mark.className = 'zk-letter-nav__mark';
    mark.setAttribute('aria-hidden', 'true');
    list.appendChild(mark);
    function moveMark(link) {
      if (desktop.matches) {
        mark.style.width = '2px';
        mark.style.height = link.offsetHeight + 'px';
        mark.style.transform = 'translateY(' + link.offsetTop + 'px)';
        return;
      }
      var item = link.parentElement;
      mark.style.height = '2px';
      mark.style.width = item.offsetWidth + 'px';
      mark.style.transform = 'translateX(' + item.offsetLeft + 'px)';
      var viewLeft = list.scrollLeft;
      var viewRight = viewLeft + list.clientWidth;
      if (item.offsetLeft < viewLeft || item.offsetLeft + item.offsetWidth > viewRight) {
        var edge = item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        list.scrollTo({ left: Math.max(0, edge), behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    function setActive(id) {
      var active = null;
      links.forEach(function (link) {
        var on = link.getAttribute('href') === '#' + id;
        link.classList.toggle('is-active', on);
        if (on) {
          link.setAttribute('aria-current', 'location');
          active = link;
        } else {
          link.removeAttribute('aria-current');
        }
      });
      if (active) moveMark(active);
    }
    function headingInView() {
      var header = document.querySelector('.zk-header');
      var line = desktop.matches ? 160 : (header ? header.offsetHeight : 80) + nav.offsetHeight + 8;
      var id = heads[0].id;
      heads.forEach(function (heading) {
        if (heading.getBoundingClientRect().top <= line) id = heading.id;
      });
      return id;
    }
    var desktop = window.matchMedia('(min-width: 1200px)');
    var footer = document.querySelector('.zk-footer');
    function placeNav() {
      if (!desktop.matches) {
        nav.style.top = '';
        nav.style.transform = '';
        return;
      }
      var header = document.querySelector('.zk-header');
      var stick = (header ? header.offsetHeight : 80) + 72;
      var start = (window.innerHeight - nav.offsetHeight) / 2;
      var top = Math.max(stick, start - window.scrollY);
      if (footer) {
        var limit = footer.getBoundingClientRect().top - 24;
        if (top + nav.offsetHeight > limit) top = limit - nav.offsetHeight;
      }
      nav.style.transform = 'none';
      nav.style.top = top + 'px';
    }
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href').slice(1);
        var heading = document.getElementById(id);
        if (!heading) return;
        event.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        heading.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.pushState) history.pushState(null, '', '#' + id);
      });
    });
    var frame = 0;
    window.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        placeNav();
        setActive(headingInView());
      });
    }, { passive: true });
    window.addEventListener('resize', function () {
      placeNav();
      setActive(headingInView());
    });
    nav.hidden = false;
    placeNav();
    setActive(headingInView());
    requestAnimationFrame(function () { setActive(headingInView()); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', letterNav);
  else letterNav();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-zk-header]');
    if (!header) return;
    const drawer = header.querySelector('[data-zk-drawer]');
    const toggle = header.querySelector('[data-zk-toggle]');

    // Transparent over the hero, solid black once the hero has scrolled past.
    // Threshold = bottom of .zk-hero minus the header height (falls back to
    // 80px when there is no hero on the page).
    const hero = document.querySelector('.zk-hero');
    let threshold = 80;
    function measure() {
      if (!hero) return;
      const rect = hero.getBoundingClientRect();
      threshold = Math.max(0, rect.top + window.scrollY + rect.height - header.offsetHeight);
    }
    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('is-past-hero', window.scrollY >= threshold);
        ticking = false;
      });
    }
    // Sticky header turns clear while it sits over a [data-zk-header-clear] section
    const clears = header.classList.contains('zk-header--sticky')
      ? Array.prototype.slice.call(document.querySelectorAll('[data-zk-header-clear]'))
      : [];
    if (clears.length) {
      const updateClear = function () {
        const line = header.getBoundingClientRect().bottom;
        header.classList.toggle('is-over-clear', clears.some(function (el) {
          const r = el.getBoundingClientRect();
          return r.top < line && r.bottom > line;
        }));
      };
      let clearTicking = false;
      window.addEventListener('scroll', function () {
        if (clearTicking) return;
        clearTicking = true;
        requestAnimationFrame(function () { updateClear(); clearTicking = false; });
      }, { passive: true });
      window.addEventListener('resize', updateClear, { passive: true });
      updateClear();
    }

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
    window.addEventListener('load', function () { measure(); onScroll(); });
    onScroll();

    if (!drawer || !toggle) return;

    // Safari paints :focus-visible on a scripted focus() after a tap (Chrome does not): hand focus back to the
    // toggle for keyboard users only, so closing the menu by tap leaves no yellow ring over the logo
    let keyboard = false;
    document.addEventListener('keydown', function () { keyboard = true; }, true);
    document.addEventListener('pointerdown', function () { keyboard = false; }, true);

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      header.setAttribute('data-zk-open', '');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      document.body.style.overflow = 'hidden';
      const first = drawer.querySelector('a, input, button');
      if (first) first.focus();
    }
    function closeDrawer(returnFocus) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      header.removeAttribute('data-zk-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      document.body.style.overflow = '';
      if (returnFocus !== false) {
        toggle.focus();
        if (!keyboard) toggle.blur();
      }
    }

    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) closeDrawer();
      else openDrawer();
    });
    drawer.querySelectorAll('[data-zk-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeDrawer(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    // Close when a desktop breakpoint is reached
    const mq = window.matchMedia('(min-width: 1200px)');
    mq.addEventListener('change', function (e) {
      if (e.matches && drawer.classList.contains('is-open')) closeDrawer(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-commitment"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STEP_MS = 4000;
    var mobileMq = window.matchMedia('(max-width: 749px)');

    function playMuted(v) {
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    /* Attach one rendition (mobile set on ≤749 when present, else desktop; ≤1080p) */
    function arm(v) {
      if (!v || v._zkArmed) return;
      if (!v._zkSources) {
        v._zkSources = Array.prototype.slice.call(v.querySelectorAll('source'));
        v._zkSources.forEach(function (s) { s.remove(); });
      }
      var want = mobileMq.matches ? 'mobile' : 'desktop';
      var set = v._zkSources.filter(function (s) { return s.dataset.set === want; });
      if (!set.length) set = v._zkSources.filter(function (s) { return s.dataset.set === 'desktop'; });
      if (!set.length) set = v._zkSources;
      var best = set.slice().sort(function (a, b) { return b.dataset.short - a.dataset.short; })[0];
      if (!best) return;
      var poster = (best.dataset.set === 'mobile' && v.dataset.posterMobile) || v.dataset.posterDesktop;
      if (poster && v._zkPoster !== poster) {
        v._zkPoster = poster;
        v.classList.remove('has-poster');
        var img = new Image();
        img.onload = function () { v.classList.add('has-poster'); };
        img.src = poster;
        v.poster = poster;
      }
      var el = document.createElement('source');
      el.src = best.dataset.src;
      el.type = best.type;
      el.addEventListener('error', function () { if (v._zkOnFail) v._zkOnFail(); });
      v.appendChild(el);
      v.preload = 'auto';
      v._zkArmed = true;
      v.load();
    }
    function disarm(v) {
      if (!v || !v._zkArmed) return;
      v.pause();
      v.querySelectorAll('source').forEach(function (s) { s.remove(); });
      v.classList.remove('is-ready');
      v._zkArmed = false;
      v.load();
    }

    function initCommit(root) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var video = root.querySelector('.zk-commit__video:not(.zk-commit__clip)');
      var btn = root.querySelector('.zk-commit__playpause');
      var progress = root.querySelector('.zk-commit__progress-fill');
      var cards = Array.prototype.slice.call(root.querySelectorAll('.zk-commit__card'));
      var clips = cards.map(function (c, idx) { return root.querySelector('.zk-commit__clip[data-step="' + idx + '"]'); });
      var isVideo = video && video.tagName === 'VIDEO';
      var paused = false, inView = true, i = 0, elapsed = 0, last = 0;

      function setPlaying(on) {
        root.dataset.playing = on ? 'true' : 'false';
        if (btn) btn.setAttribute('aria-label', on ? 'Pause' : 'Play');
      }
      function running() { return !paused && inView; }

      /* Stepped highlight: a step with its own video lasts until the video ends, otherwise STEP_MS */
      function show(n) {
        i = n;
        elapsed = 0;
        cards.forEach(function (c, idx) {
          c.classList.toggle('is-active', idx === n);
          var fill = c.querySelector('.zk-commit__bar-fill');
          if (fill) fill.style.width = '0%';
        });
        clips.forEach(function (v, idx) {
          if (!v) return;
          v.classList.toggle('is-active', idx === n);
          if (idx !== n) v.pause();
        });
        var v = clips[n];
        if (v) {
          arm(v);
          try { v.currentTime = 0; } catch (e) {}
          if (running()) playMuted(v);
        }
        arm(clips[(n + 1) % cards.length]);
      }
      function next() { show((i + 1) % cards.length); }

      function tick(now) {
        var dt = last ? now - last : 0;
        last = now;
        if (running() && cards.length) {
          var v = clips[i], f;
          if (v) {
            f = v.duration ? v.currentTime / v.duration : 0;
          } else {
            elapsed += dt;
            f = Math.min(1, elapsed / STEP_MS);
          }
          var fill = cards[i].querySelector('.zk-commit__bar-fill');
          if (fill) fill.style.width = (f * 100) + '%';
          if (progress) progress.style.width = (f * 100) + '%';
          if (!v && elapsed >= STEP_MS) next();
        }
        requestAnimationFrame(tick);
      }

      function pauseMedia() {
        if (isVideo) video.pause();
        if (clips[i]) clips[i].pause();
      }
      function resumeMedia() {
        if (isVideo) playMuted(video);
        if (clips[i]) playMuted(clips[i]);
      }
      function pause() { paused = true; pauseMedia(); setPlaying(false); }
      function play() { paused = false; if (inView) resumeMedia(); setPlaying(true); }

      clips.forEach(function (v, idx) {
        if (!v) return;
        v.addEventListener('playing', function () { v.classList.add('is-ready'); });
        v.addEventListener('loadeddata', function () { v.classList.add('is-ready'); });
        v.addEventListener('ended', function () { if (idx === i) next(); });
        v._zkOnFail = function () {
          clips[idx] = null;
          if (idx === i) elapsed = 0;
        };
      });

      if (reduce) {
        if (isVideo) { video.removeAttribute('autoplay'); video.pause(); }
        cards.forEach(function (c) { c.classList.add('is-active'); });
        setPlaying(false);
        if (btn) btn.addEventListener('click', function () { if (isVideo) { if (video.paused) { video.play(); setPlaying(true); } else { video.pause(); setPlaying(false); } } });
        return;
      }

      if (isVideo) playMuted(video);
      setPlaying(true);
      if (cards.length) show(0);
      requestAnimationFrame(tick);
      if (btn) btn.addEventListener('click', function () { if (paused) play(); else pause(); });

      cards.forEach(function (c, idx) {
        c.addEventListener('click', function () { if (idx !== i) show(idx); });
        c.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          if (idx !== i) show(idx);
        });
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          if (paused) return;
          if (inView) resumeMedia(); else pauseMedia();
        }).observe(root);
      }
      var onMq = function () {
        clips.forEach(disarm);
        if (cards.length) show(i);
      };
      if (mobileMq.addEventListener) mobileMq.addEventListener('change', onMq);
      else if (mobileMq.addListener) mobileMq.addListener(onMq);
    }
    document.querySelectorAll('[data-zk-commit]').forEach(initCommit);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-zk-slide]'));
      var btn = root.querySelector('.zk-hero__playpause');
      var fill = root.querySelector('.zk-hero__progress-fill');
      var scroll = root.querySelector('.zk-hero__scroll');
      var duration = (parseFloat(root.dataset.duration) || 6) * 1000;
      var idx = 0, startTs = 0, pausedAt = 0, paused = false, raf = 0;

      var soundBtn = root.querySelector('.zk-hero__sound');
      var soundOn = false;
      var portrait = window.matchMedia('(max-aspect-ratio: 1/1)');

      function video(slide) { var v = slide.querySelector('video'); return v && v.tagName === 'VIDEO' ? v : null; }

      // Every rendition of both cuts, kept so a rotation can re-pick from the full list
      slides.forEach(function (s) {
        var v = video(s);
        if (!v) return;
        v._zkSources = Array.prototype.slice.call(v.querySelectorAll('source[data-src]'));
        v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      });

      // Portrait viewports use the mobile cut when the slide has one
      function sourcesFor(v) {
        var all = v._zkSources || [];
        var set = portrait.matches && all.some(function (s) { return s.dataset.set === 'mobile'; }) ? 'mobile' : 'desktop';
        return all.filter(function (s) { return s.dataset.set === set; })
          .sort(function (a, b) { return (+a.dataset.short || 0) - (+b.dataset.short || 0); });
      }

      // Sources are rendered as data-src so nothing downloads until we choose one.
      // Pick the smallest rendition whose short side covers the cover-cropped viewport (×DPR, capped at 1080).
      function armVideo(v) {
        if (!v || v.dataset.armed) return;
        v.dataset.armed = '1';
        var sources = sourcesFor(v);
        var w = window.innerWidth, h = window.innerHeight;
        var mobileCut = sources.length && sources[0].dataset.set === 'mobile';
        var need = Math.min(1080, Math.ceil((mobileCut ? Math.max(w, h * 9 / 16) : Math.max(h, w * 9 / 16)) * Math.min(window.devicePixelRatio || 1, 2)));
        var pick = sources.filter(function (s) { return (+s.dataset.short || 0) >= need; })[0] || sources[sources.length - 1];
        Array.prototype.forEach.call(v.querySelectorAll('source'), function (s) { s.remove(); });
        if (pick) { pick.src = pick.dataset.src; v.appendChild(pick); v.load(); }
      }
      function disarmVideo(v) {
        if (!v || !v.dataset.armed) return;
        v.pause();
        delete v.dataset.armed;
        v.classList.remove('is-playing');
      }

      // Sound defaults to on; browsers that block audible autoplay fall back to muted
      function setSound(on) {
        soundOn = on;
        root.classList.toggle('is-muted', !on);
        if (soundBtn) {
          soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
          soundBtn.setAttribute('aria-label', on ? 'Sound on' : 'Sound off');
        }
        slides.forEach(function (s) { var v = video(s); if (v) v.muted = !on || !s.classList.contains('is-active'); });
      }
      function playVideo(v) {
        v.muted = !soundOn;
        var p = v.play();
        if (p && p.catch) p.catch(function (err) {
          if (err && err.name === 'NotAllowedError' && !v.muted) {
            setSound(false);
            v.muted = true;
            v.play().catch(function () {});
          }
        });
      }
      function setFill(p) { if (fill) fill.style.width = (Math.max(0, Math.min(1, p)) * 100) + '%'; }
      function setPlaying(on) {
        root.dataset.playing = on ? 'true' : 'false';
        if (btn) btn.setAttribute('aria-label', on ? 'Pause background video' : 'Play background video');
      }

      function show(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          var on = k === idx, v = video(s);
          s.classList.toggle('is-active', on);
          if (!v) return;
          if (on && !paused && !reduce) { armVideo(v); try { v.currentTime = 0; } catch (e) {} playVideo(v); }
          else { v.pause(); v.muted = true; }
        });
        // Warm up the next slide's video so the switch is seamless
        var nxt = video(slides[(idx + 1) % slides.length]);
        if (nxt && slides.length > 1 && !reduce) armVideo(nxt);
        startTs = performance.now();
        setFill(0);
      }
      function next() { if (slides.length > 1) show(idx + 1); else startTs = performance.now(); }

      function tick(now) {
        if (!paused) {
          var v = video(slides[idx]);
          if (v && v.duration) {
            setFill(v.currentTime / v.duration);
            if (slides.length > 1 && v.ended) next();
          } else {
            var p = (now - startTs) / duration;
            if (p >= 1) { next(); p = 0; }
            setFill(p);
          }
        }
        raf = requestAnimationFrame(tick);
      }

      function pause() {
        paused = true; pausedAt = performance.now();
        var v = video(slides[idx]); if (v) v.pause();
        setPlaying(false);
      }
      function play() {
        paused = false; startTs += performance.now() - pausedAt;
        var v = video(slides[idx]); if (v) playVideo(v);
        setPlaying(true);
      }

      if (!slides.length) return;
      // Video is deferred: the still image is the LCP; the (heavy) video stream must not
      // compete with the page load. Also skip video on phones unless a ≤720p rendition
      // exists, and whenever the user asked to save data.
      var saveData = navigator.connection && navigator.connection.saveData;
      var smallScreen = window.matchMedia('(max-width: 749px)').matches;
      var videoAllowed = !saveData;
      function lightEnoughForPhone(v) {
        var hs = sourcesFor(v).map(function (x) { return +x.dataset.short || 9999; });
        return hs.length && Math.min.apply(null, hs) <= 720;
      }
      var videoReady = false;
      function whenIdle(fn) {
        var go = function () { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 2500 }); else setTimeout(fn, 1200); };
        if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
      }
      var _armVideo = armVideo;
      armVideo = function (v) {
        if (!videoAllowed || !v) return;
        if (smallScreen && !lightEnoughForPhone(v)) return;   // still image only
        if (!videoReady) return;                               // wait for whenIdle → show(idx)
        _armVideo(v);
      };
      whenIdle(function () { videoReady = true; if (!paused && !reduce) show(idx); });

      show(0);
      if (reduce) {
        // No autoplay, no rotation: static first slide, controls start "paused".
        setPlaying(false); paused = true;
        setFill(0);
      } else {
        setPlaying(true);
        raf = requestAnimationFrame(tick);
      }
      slides.forEach(function (s) {
        var v = video(s);
        if (v) v.addEventListener('ended', function () { if (!paused && slides.length > 1 && s.classList.contains('is-active')) next(); });
      });
      if (btn) btn.addEventListener('click', function () {
        if (paused) { if (!raf) raf = requestAnimationFrame(tick); play(); } else { pause(); }
      });
      if (soundBtn) soundBtn.addEventListener('click', function () { setSound(!soundOn); });

      // Rotating a phone/tablet switches between the mobile and desktop cuts
      var onOrientation = function () {
        slides.forEach(function (s) { disarmVideo(video(s)); });
        if (!paused && !reduce) show(idx);
      };
      if (portrait.addEventListener) portrait.addEventListener('change', onOrientation);
      else if (portrait.addListener) portrait.addListener(onOrientation);

      // Pause everything while the hero is off-screen (saves battery on mobile).
      if ('IntersectionObserver' in window && !reduce) {
        var wasPausedByUser = false;
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting && !paused) { wasPausedByUser = false; pause(); }
            else if (e.isIntersecting && paused && !wasPausedByUser) { play(); }
          });
        }, { threshold: 0.05 }).observe(root);
        if (btn) btn.addEventListener('click', function () { wasPausedByUser = paused; });
      }

      if (scroll) {
        scroll.addEventListener('click', function () {
          var section = root.closest('.shopify-section') || root;
          var target = section.nextElementSibling;
          if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          else window.scrollBy({ top: window.innerHeight, behavior: reduce ? 'auto' : 'smooth' });
        });
      }
    }
    document.querySelectorAll('[data-zk-hero]').forEach(initHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-knife-types"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initKnives(root) {
      var track = root.querySelector('.zk-knives__track');
      var chips = root.querySelectorAll('.zk-knives__filters [data-filter]');
      var prev = root.querySelector('[data-dir="prev"]');
      var next = root.querySelector('[data-dir="next"]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var touch = !window.matchMedia('(hover: hover)').matches;
      if (!track) return;

      function step() {
        var card = track.querySelector('.zk-knives__card:not([hidden])');
        return card ? card.getBoundingClientRect().width : 320;
      }
      function scrollBy(dir) {
        track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
      }
      var shell = root.querySelector('.zk-knives__track-shell');
      function updateArrows() {
        var hasLeft = track.scrollLeft > 1;
        var hasRight = track.scrollLeft + track.clientWidth < track.scrollWidth - 1;
        if (shell) {
          shell.classList.toggle('has-left-fade', hasLeft);
          shell.classList.toggle('has-right-fade', hasRight);
        }
        if (!prev || !next) return;
        prev.disabled = !hasLeft;
        next.disabled = !hasRight;
      }
      if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
      if (next) next.addEventListener('click', function () { scrollBy(1); });
      track.addEventListener('scroll', updateArrows, { passive: true });

      // Filter chips
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var filter = chip.getAttribute('data-filter');
          chips.forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('zk-chip--active', on);
            c.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          root.querySelectorAll('.zk-knives__card').forEach(function (card) {
            card.hidden = filter !== 'all' && card.getAttribute('data-category') !== filter;
          });
          // Filtering swaps the cards; it must not animate the carousel back to the start
          // (behavior: 'auto' still honours the track's CSS scroll-behavior: smooth).
          track.style.scrollBehavior = 'auto';
          track.scrollTo({ left: 0 });
          track.style.scrollBehavior = '';
          updateArrows();
        });
      });

      // Touch screens: the card most in view gets the "hover" look (Figma annotation)
      if (touch && 'IntersectionObserver' in window) {
        var ratios = new Map();
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { ratios.set(e.target, e.intersectionRatio); });
          var best = null, bestR = 0;
          ratios.forEach(function (r, el) { if (!el.hidden && r > bestR) { bestR = r; best = el; } });
          root.querySelectorAll('.zk-knives__card').forEach(function (c) { c.classList.toggle('is-active', c === best); });
        }, { root: track, threshold: [0.25, 0.5, 0.75, 1] });
        root.querySelectorAll('.zk-knives__card').forEach(function (c) { io.observe(c); });
      }

      // Drag to scroll (mouse)
      var down = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        // Only becomes a drag after 4px: a plain click keeps pointer-events on the cards
        if (Math.abs(dx) > 4 && !moved) { moved = true; track.classList.add('is-dragging'); }
        if (moved) track.scrollLeft = startLeft - dx;
      });
      function endDrag() { down = false; track.classList.remove('is-dragging'); }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      updateArrows();
      window.addEventListener('resize', updateArrows);
    }
    document.querySelectorAll('.zk-knives').forEach(initKnives);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-know-your-knife"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initKnife(root) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var hotspots = Array.prototype.slice.call(root.querySelectorAll('.zk-kyk__hotspot'));

      /* ---- Scroll-linked entrance (tilt -15° → 0°, pins 0 → 1) ---- */
      if (!reduce) {
        var ticking = false;
        function clamp(v) { return Math.max(0, Math.min(1, v)); }
        function update() {
          ticking = false;
          var r = root.getBoundingClientRect();
          var vh = window.innerHeight;
          // 0: section top at viewport bottom · 1: section bottom at viewport bottom
          var p = clamp((vh - r.top) / r.height);
          var tilt = -15 * (1 - clamp((p - 0.5) / 0.5));      // 50% → 100%
          var pins = clamp((p - 0.7) / 0.3);                   // 70% → 100%
          root.style.setProperty('--kyk-tilt', tilt.toFixed(2) + 'deg');
          root.style.setProperty('--kyk-pins', pins.toFixed(3));
        }
        function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        update();
      }

      /* ---- Hotspot cards ---- */
      if (!hotspots.length) return;
      function items() {
        return hotspots.map(function (h) {
          return { pin: h.querySelector('.zk-kyk__pin'), card: h.querySelector('.zk-kyk__card') };
        });
      }
      var detail = root.querySelector('[data-zk-kyk-detail]');
      var mobile = window.matchMedia('(max-width: 749px)');
      function close(it) {
        it.pin.setAttribute('aria-expanded', 'false'); it.card.hidden = true; it.pin.parentElement.classList.remove('is-open');
        if (detail && detail.dataset.for === it.pin.getAttribute('aria-controls')) { detail.hidden = true; detail.dataset.for = ''; }
      }
      function open(it) {
        items().forEach(function (other) { if (other.pin !== it.pin) close(other); });
        it.pin.setAttribute('aria-expanded', 'true');
        it.card.hidden = false;
        it.pin.parentElement.classList.add('is-open');
        if (detail && mobile.matches) {
          // Re-trigger the entrance animation and show the panel under the knife
          detail.hidden = true;
          detail.innerHTML = it.card.innerHTML;
          detail.dataset.for = it.pin.getAttribute('aria-controls');
          void detail.offsetWidth;
          detail.hidden = false;
        }
      }
      function toggle(it) { if (it.pin.getAttribute('aria-expanded') === 'true') close(it); else open(it); }

      items().forEach(function (it) {
        // Hover is for real mice only. Devices that claim (hover: hover) but are tapped
        // (iPad, some Android) got an emulated mouseenter → open, then click → toggle →
        // close: the card needed two taps, and a tap on SHOP KNIVES was eaten by the
        // mouseleave close. pointerType tells touch from mouse; mouseenter cannot.
        var byHover = false;
        var wrap = it.pin.closest('.zk-kyk__hotspot');
        wrap.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { byHover = true; open(it); } });
        wrap.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { byHover = false; close(it); } });
        // A mouse click on a hover-opened pin keeps it open (it used to toggle it closed).
        it.pin.addEventListener('click', function () { if (byHover) return; toggle(it); });
        it.pin.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(it); it.pin.focus(); } });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') items().forEach(close); });
      document.addEventListener('pointerdown', function (e) {
        if (!root.contains(e.target)) items().forEach(close);
      });
    }
    document.querySelectorAll('[data-zk-kyk]').forEach(initKnife);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-philosophy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Mobile only (Figma "Display card animation"): while the section scrolls up through
    // the viewport, the pillar cards — and the 改善/CRAFTSMANSHIP pill strip — slide
    // horizontally from start to end, on the same timing (both driven by the cards' position).
    //   0%  = cards fully in view (its bottom at the viewport bottom)
    //   100% = element top reaching the 80px header
    // The strip eases toward its target each frame (lerp) instead of jumping with the
    // scroll, so it reads as a smooth glide. A finger on the strip pauses the link so
    // manual swipes still work. Off under prefers-reduced-motion.
    var HEADER = 80, EASE = 0.08;

    // `driver` is the element whose position defines the progress; `speed` > 1 finishes the
    // glide that much earlier in the element's travel (1 = done when its top meets the header).
    function link(el, driver, speed) {
      driver = driver || el;
      speed = speed || 1;
      var mobile = window.matchMedia('(max-width: 749px)');
      var touching = false, target = 0, raf = 0;

      function progress() {
        var r = driver.getBoundingClientRect();
        var vh = window.innerHeight;
        var range = Math.max(1, vh - HEADER - r.height);
        return Math.max(0, Math.min(1, (vh - r.bottom) / range * speed));
      }
      function step() {
        raf = 0;
        if (!mobile.matches || touching) return;
        var diff = target - el.scrollLeft;
        if (Math.abs(diff) < 0.5) { el.scrollLeft = target; return; }
        el.scrollLeft += diff * EASE;
        raf = requestAnimationFrame(step);
      }
      function onScroll() {
        if (!mobile.matches || touching) return;
        target = progress() * Math.max(0, el.scrollWidth - el.clientWidth);
        if (!raf) raf = requestAnimationFrame(step);
      }
      function apply() {
        el.classList.toggle('is-linked', mobile.matches);
        if (mobile.matches) { target = progress() * Math.max(0, el.scrollWidth - el.clientWidth); el.scrollLeft = target; }
      }

      el.addEventListener('pointerdown', function () { touching = true; });
      el.addEventListener('touchstart', function () { touching = true; }, { passive: true });
      ['pointerup', 'pointercancel', 'touchend'].forEach(function (n) {
        window.addEventListener(n, function () { touching = false; }, { passive: true });
      });
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', apply, { passive: true });
      if (mobile.addEventListener) mobile.addEventListener('change', apply); else mobile.addListener(apply);
      apply();
    }

    // ≥750 (Framer HomePhilosophy): cards fade 0→1 and settle down from 80/120/180px while
    // the row travels from the viewport bottom to the 80px header, eased toward the scroll.
    var OFFSETS = [80, 120, 180], REVEAL_EASE = 0.2, MARQUEE_SPEED = 49;

    function reveal(section, track) {
      var wide = window.matchMedia('(min-width: 750px)');
      var cur = 1, target = 1, raf = 0;
      Array.prototype.forEach.call(track.children, function (card, i) {
        card.style.setProperty('--zk-reveal-offset', OFFSETS[Math.min(i, OFFSETS.length - 1)] + 'px');
      });
      function progress() {
        var vh = window.innerHeight;
        var top = track.getBoundingClientRect().top;
        return Math.max(0, Math.min(1, (vh - top) / Math.max(1, vh - HEADER)));
      }
      function paint() { section.style.setProperty('--zk-reveal', cur.toFixed(4)); }
      function step() {
        raf = 0;
        var diff = target - cur;
        cur = Math.abs(diff) < 0.001 ? target : cur + diff * REVEAL_EASE;
        paint();
        if (cur !== target) raf = requestAnimationFrame(step);
      }
      function onScroll() {
        if (!wide.matches) return;
        target = progress();
        if (!raf) raf = requestAnimationFrame(step);
      }
      function apply() {
        section.classList.toggle('is-reveal', wide.matches);
        cur = target = progress();
        paint();
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', apply, { passive: true });
      if (wide.addEventListener) wide.addEventListener('change', apply); else wide.addListener(apply);
      apply();
    }

    function marquee(trackEl) {
      function size() {
        var copy = trackEl.firstElementChild;
        if (copy && copy.offsetWidth) trackEl.style.setProperty('--zk-marquee-duration', (copy.offsetWidth / MARQUEE_SPEED).toFixed(2) + 's');
      }
      size();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(size);
      window.addEventListener('resize', size, { passive: true });
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-zk-marquee]').forEach(marquee);
    document.querySelectorAll('[data-zk-pillars]').forEach(function (track) {
      reveal(track.closest('.zk-philosophy'), track);
      link(track);
      var pill = track.closest('.zk-philosophy').querySelector('.zk-philosophy__pill-scroll');
      // The strip used to follow the cards' timing, but it sits above them: it was still
      // scrolling when it slid under the 80px header. Its own position, finishing while it
      // is still in the top third of the screen, keeps the whole line readable.
      if (pill) link(pill, null, 1.5);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-stores"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LEAFLET_JS = document.querySelector('[data-zk-stores]') && document.querySelector('[data-zk-stores]').dataset.leaflet;
    var DEFAULT_TILES = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
    var ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

    // Yellow ZAKU pin (Figma Marker 406:52584): teardrop + black ZA/KU mark
    var PIN = '<svg viewBox="0 0 50 76" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M25 0C11.2 0 0 11.1 0 24.8 0 43.4 25 76 25 76S50 43.4 50 24.8C50 11.1 38.8 0 25 0Z" fill="#FFBB00"/>' +
      '<g transform="translate(15.5 12.5) scale(0.5)">' +
      '<path d="M5.85 24.89v8.95h.06l6.98-8.95h10.95v14.65l1.72 2.73h3.88l1.71-2.73V24.89H37v14.31c0 5.03-3.78 8.8-9.71 8.8-5.6 0-9.29-3.56-9.29-9.16h-.01V26.71l-7.44 8.93 9.92 11.97h-7.53l-7.04-9.01-.06.06v8.95H0V24.89h5.85Z" fill="#000"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M36.24 22.72h-5.84v-2.88h-5.69l-1.67 2.88H.8v.01l-.03-.09L11.23 5.25H2.05V0h18.73l.03.09L10.15 18.28h.4c5.1 0 9.82-2.66 12.5-7l6.79-11.28h6.4v22.72ZM27.39 15.23h3.01v-5.17l-3.01 5.17Z" fill="#000"/>' +
      '</g></svg>';

    function loadLeaflet(cb) {
      // Stylesheet is injected here, so it never blocks first paint of the page
      var root0 = document.querySelector('[data-zk-stores]');
      if (root0 && root0.dataset.leafletCss && !document.querySelector('link[data-zk-leaflet]')) {
        var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = root0.dataset.leafletCss; l.setAttribute('data-zk-leaflet', '');
        document.head.appendChild(l);
      }
      if (window.L && window.L.map) return cb();
      var s = document.createElement('script');
      s.src = LEAFLET_JS; s.async = true;
      s.onload = cb;
      s.onerror = function () {};
      document.head.appendChild(s);
    }

    function initStores(root) {
      var list = root.querySelector('.zk-stores__list');
      if (list) {
        var onListScroll = function () { root.classList.toggle('is-list-scrolled', list.scrollTop > 0); };
        list.addEventListener('scroll', onListScroll, { passive: true });
        onListScroll();
      }
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-zk-store]'));
      cards.forEach(function (c) {
        c.addEventListener('mouseenter', function () { c.classList.add('is-active'); if (c._zkMarker) setPinActive(c._zkMarker, true); });
        c.addEventListener('mouseleave', function () { c.classList.remove('is-active'); if (c._zkMarker) setPinActive(c._zkMarker, false); });
        var link = c.querySelector('.zk-stores__visit, .zk-stores__visit-icon');
        if (link) {
          c.classList.add('is-clickable');
          c.addEventListener('click', function (e) {
            if (e.target.closest('a') || (window.getSelection && String(window.getSelection()))) return;
            window.open(link.href, '_blank', 'noopener');
          });
        }
      });
      function setPinActive(m, on) {
        var pin = m.getElement();
        if (pin) pin.classList.toggle('is-active', on);
        if (on) m.openTooltip(); else m.closeTooltip();
      }
      // Region filter: hides the other cards and their pins, refits the map, updates the count
      var countEl = root.querySelector('[data-zk-stores-count]');
      var filters = Array.prototype.slice.call(root.querySelectorAll('[data-zk-region]'));
      filters.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var region = btn.getAttribute('data-zk-region');
          filters.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          var shown = 0, last = null;
          cards.forEach(function (c) {
            c.hidden = region !== 'all' && c.dataset.region !== region;
            c.classList.remove('is-last-shown');
            if (!c.hidden) { shown++; last = c; }
          });
          if (last) last.classList.add('is-last-shown');
          if (countEl) countEl.textContent = shown + (shown === 1 ? ' store' : ' stores');
          if (list) list.scrollTop = 0;
          if (root._zkMapFilter) root._zkMapFilter();
        });
      });

      var el = root.querySelector('[data-zk-map]');
      if (!el) return;
      var stores = cards
        .map(function (c) { return { lat: parseFloat(c.dataset.lat), lng: parseFloat(c.dataset.lng), name: c.dataset.name, address: c.dataset.address, card: c }; })
        .filter(function (s) { return !isNaN(s.lat) && !isNaN(s.lng); });
      if (!stores.length) return;

      function build() {
        if (!window.L) return;
        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var compact = root.classList.contains('zk-stores--compact');
        var smallPin = isMobile || compact;
        var map = L.map(el, {
          scrollWheelZoom: false,       // don't hijack page scroll; drag + pinch/buttons still work
          touchZoom: true,
          zoomControl: false,
          attributionControl: true
        });
        // iOS pinch-zooms the page unless the map cancels the gesture. Leaflet
        // still receives the touch events and zooms the map.
        var stopPageZoom = function (e) { e.preventDefault(); };
        ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (type) {
          el.addEventListener(type, stopPageZoom, { passive: false, capture: true });
        });
        el.addEventListener('touchmove', function (e) {
          if (e.touches.length > 1) e.preventDefault();
        }, { passive: false });
        var tiles = root.dataset.tiles || DEFAULT_TILES;
        L.tileLayer(tiles, { attribution: root.dataset.attribution || ATTR, maxZoom: 19 }).addTo(map);
        var icon = L.divIcon({
          className: 'zk-stores__pin',
          html: PIN,
          iconSize: smallPin ? [27, 41] : [50, 76],
          iconAnchor: smallPin ? [13.5, 41] : [25, 76],
          tooltipAnchor: smallPin ? [0, -44] : [0, -80]
        });
        stores.forEach(function (s) {
          var m = L.marker([s.lat, s.lng], { icon: icon, title: s.name, keyboard: false });
          if (!s.card.hidden) m.addTo(map);
          s.marker = m;
          if (s.address) m.bindTooltip(s.address, { direction: 'top', className: 'zk-stores__callout', opacity: 1 });
          s.card._zkMarker = m;
          m.on('mouseover', function () { s.card.classList.add('is-active'); var pin = m.getElement(); if (pin) pin.classList.add('is-active'); });
          m.on('mouseout', function () { s.card.classList.remove('is-active'); var pin = m.getElement(); if (pin) pin.classList.remove('is-active'); });
        });
        function showAll(animate) {
          var bounds = stores.filter(function (s) { return !s.card.hidden; }).map(function (s) { return [s.lat, s.lng]; });
          if (!bounds.length) return;
          if (bounds.length === 1) map.setView(bounds[0], 16, { animate: animate });
          else map.fitBounds(bounds, { padding: compact ? [28, 28] : (isMobile ? [60, 40] : [120, 120]), maxZoom: 16, animate: animate });
        }
        showAll(false);
        root._zkMapFilter = function () {
          stores.forEach(function (s) {
            if (s.card.hidden) map.removeLayer(s.marker); else if (!map.hasLayer(s.marker)) s.marker.addTo(map);
          });
          showAll(true);
        };
        var zoomIn = root.querySelector('[data-zk-zoom-in]');
        var zoomOut = root.querySelector('[data-zk-zoom-out]');
        var zoomAll = root.querySelector('[data-zk-zoom-all]');
        if (zoomIn) zoomIn.addEventListener('click', function () { map.zoomIn(); });
        if (zoomOut) zoomOut.addEventListener('click', function () { map.zoomOut(); });
        if (zoomAll) zoomAll.addEventListener('click', function () { showAll(true); });
        function syncZoomButtons() {
          var z = map.getZoom();
          if (zoomIn) zoomIn.disabled = z >= map.getMaxZoom();
          if (zoomOut) zoomOut.disabled = z <= map.getMinZoom();
        }
        map.on('zoomend', syncZoomButtons);
        // Keep the controls clear of the fixed site header when it overlaps the top of the map
        var ctl = root.querySelector('.zk-stores__mapctl');
        var header = document.querySelector('.zk-header');
        if (ctl && header) {
          var ticking = false;
          var placeCtl = function () {
            ticking = false;
            var hb = header.getBoundingClientRect();
            var overlap = hb.bottom > 0 && getComputedStyle(header).visibility !== 'hidden' ? hb.bottom - el.getBoundingClientRect().top : 0;
            ctl.style.transform = overlap > 0 ? 'translateY(' + Math.round(overlap) + 'px)' : '';
          };
          var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(placeCtl); } };
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll);
          placeCtl();
        }
        el.classList.add('is-ready');
        root.classList.add('zk-stores--live');
        // Leaflet measured a display:none box before is-ready; re-measure now it is visible.
        setTimeout(function () { map.invalidateSize(); showAll(false); syncZoomButtons(); }, 0);
        window.addEventListener('resize', function () { map.invalidateSize(); });
      }

      // Load lazily: only when the section is near the viewport
      var started = false;
      function start() { if (started) return; started = true; loadLeaflet(build); }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { start(); io.disconnect(); }
        }, { rootMargin: '600px 0px' });
        io.observe(root);
      } else { start(); }
    }
    document.querySelectorAll('[data-zk-stores]').forEach(initStores);
    document.querySelectorAll('.zk-stores [data-gallery]').forEach(function (g) {
      function start() { if (window.zkGallery) window.zkGallery(g); }
      if (window.zkGallery) start();
      else document.addEventListener('DOMContentLoaded', start);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStories(root) {
      var track = root.querySelector('[data-stories-track]');
      if (!track) return;
      var prev = root.querySelector('[data-dir="prev"]');
      var next = root.querySelector('[data-dir="next"]');

      function positions() {
        var cards = track.querySelectorAll('.zk-blog-card');
        var base = cards.length ? cards[0].offsetLeft : 0;
        return Array.prototype.map.call(cards, function (c) { return c.offsetLeft - base; });
      }
      function update() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= max;
      }
      // Scroll to the next/previous card's own snap position (not scrollLeft ± width),
      // remembering the target so rapid clicks chain cleanly instead of fighting the snap.
      var target = null, settle;
      function go(dir) {
        var from = target === null ? track.scrollLeft : target;
        var max = Math.max(track.scrollWidth - track.clientWidth, 0);
        var pos = positions(), to = null, i;
        if (dir > 0) { for (i = 0; i < pos.length; i++) { if (pos[i] > from + 1) { to = pos[i]; break; } } }
        else { for (i = pos.length - 1; i >= 0; i--) { if (pos[i] < from - 1) { to = pos[i]; break; } } }
        if (to === null) to = dir > 0 ? max : 0;
        target = Math.min(Math.max(to, 0), max);
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () {
        update();
        clearTimeout(settle);
        settle = setTimeout(function () { target = null; }, 150);
      }, { passive: true });
      update();

      // Mouse drag-to-scroll. Touch/pen are left to the browser: native panning already
      // snaps and has inertia, and running both at once made the drag stutter.
      var down = false, startX = 0, startLeft = 0, moved = false, pending = null, raf = 0;
      function applyDrag() { raf = 0; if (pending !== null) { track.scrollLeft = pending; pending = null; } }
      // Cards are links with images: native drag-and-drop would hijack the gesture mid-drag.
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; target = null;
        startX = e.clientX; startLeft = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4 && !moved) { moved = true; track.classList.add('is-dragging'); track.setPointerCapture(e.pointerId); }
        if (!moved) return;
        pending = startLeft - dx;                 // one scroll write per frame, not per pointermove
        if (!raf) raf = requestAnimationFrame(applyDrag);
      });
      function end() {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
        update();
      }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); } }, true);
    }
    document.querySelectorAll('.zk-stories').forEach(initStories);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knife-why-choose"] && !Shopify.designMode) return;
  try {
    
  // Runs on load and again after the PDP variant switcher swaps this section in (zkInitSwapped)
  function zkWhyInit(scope) {
    scope = scope || document;
    // Mobile: the side-label pill glides sideways as the section scrolls through the viewport
    (function linkPills() {
      var mobile = window.matchMedia('(max-width: 749px)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      // Slow glide: the pill needs ~1.6 viewports of page scroll to travel end to end,
      // starting only once the section header has actually entered the viewport.
      var EASE = 0.05, TRAVEL = 1.6;
      scope.querySelectorAll('.zk-why__pill-scroll').forEach(function (el) {
        var touching = false, target = 0, raf = 0;
        function progress() {
          var r = el.getBoundingClientRect();
          var vh = window.innerHeight;
          var range = Math.max(1, vh * TRAVEL);
          return Math.max(0, Math.min(1, (vh - r.bottom) / range));
        }
        function step() {
          raf = 0;
          if (!mobile.matches || touching) return;
          var diff = target - el.scrollLeft;
          if (Math.abs(diff) < 0.5) { el.scrollLeft = target; return; }
          el.scrollLeft += diff * EASE;
          raf = requestAnimationFrame(step);
        }
        function onScroll() {
          if (!el.isConnected || !mobile.matches || touching) return;
          target = progress() * Math.max(0, el.scrollWidth - el.clientWidth);
          if (!raf) raf = requestAnimationFrame(step);
        }
        function apply() { el.classList.toggle('is-linked', mobile.matches); if (mobile.matches) onScroll(); }
        el.addEventListener('touchstart', function () { touching = true; }, { passive: true });
        window.addEventListener('touchend', function () { touching = false; }, { passive: true });
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', apply, { passive: true });
        if (mobile.addEventListener) mobile.addEventListener('change', apply); else mobile.addListener(apply);
        apply();
      });
    })();

    scope.querySelectorAll('.zk-why__card--video').forEach(function (card) {
      var video = card.querySelector('video');
      var btn = card.querySelector('.zk-why__playpause');
      if (!video || !btn) return;
      var playLabel = btn.getAttribute('aria-label');
      var pauseLabel = playLabel.replace(/^Play/, 'Pause');
      var sound = card.querySelector('.zk-why__sound');
      var soundOn = !!sound;
      function setSound(on) {
        soundOn = on;
        card.classList.toggle('is-muted', !on);
        if (!sound) return;
        sound.setAttribute('aria-pressed', on ? 'true' : 'false');
        sound.setAttribute('aria-label', on ? 'Sound on' : 'Sound off');
        if (!video.paused) video.muted = !on;
      }
      function toggle() {
        if (!video.paused) { video.pause(); return; }
        video.muted = !soundOn;
        var p = video.play();
        // Browser refused audible playback: fall back to muted so the video still plays
        if (p && p.catch) p.catch(function () { if (!video.muted) { setSound(false); video.muted = true; video.play().catch(function () {}); } });
      }
      if (sound) sound.addEventListener('click', function (e) { e.stopPropagation(); setSound(!soundOn); });
      video.addEventListener('play', function () { card.classList.remove('is-paused'); btn.setAttribute('aria-label', pauseLabel); });
      video.addEventListener('pause', function () { card.classList.add('is-paused'); btn.setAttribute('aria-label', playLabel); });
      // The whole card is a click target; the button stays the keyboard-focusable control
      card.addEventListener('click', toggle);
    });
  }
  zkWhyInit();
  var zkPrevInit = window.zkInitSwapped;
  window.zkInitSwapped = function (el) { if (zkPrevInit) zkPrevInit(el); if (el.querySelector('.zk-why')) zkWhyInit(el); };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  document.querySelectorAll('.zk-blog').forEach(function (root) {
    // The category chips overflow on mobile and a tap navigates to the category blog, so on
    // load the row is scrolled (sideways only, never the page) to centre the active chip.
    var chipRow = root.querySelector('.zk-blog__chips');
    var activeChip = chipRow && chipRow.querySelector('.zk-chip--active');
    if (chipRow && activeChip && chipRow.scrollWidth > chipRow.clientWidth) {
      var left = activeChip.getBoundingClientRect().left - chipRow.getBoundingClientRect().left + chipRow.scrollLeft;
      chipRow.scrollLeft = Math.max(0, left - (chipRow.clientWidth - activeChip.offsetWidth) / 2);
    }

    var grid = root.querySelector('[data-blog-grid]');
    var btn = root.querySelector('[data-blog-more]');
    var sel = root.querySelector('[data-blog-sort]');
    if (!grid) return;
    var per = btn ? parseInt(btn.getAttribute('data-blog-more'), 10) || 8 : Infinity;
    var shown = per;
    function paint(from) {
      Array.prototype.forEach.call(grid.children, function (c, i) {
        c.classList.toggle('is-hidden', i >= shown);
        if (from !== undefined && i >= from && i < shown) c.classList.add('is-new'); // fade the revealed batch in
      });
      if (btn) btn.parentNode.hidden = shown >= grid.children.length; // last page: no button
    }
    if (btn) btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-busy') === 'true') return;
      // The cards are already in the DOM; the short busy beat is feedback while their
      // lazy images start loading, so the click never feels ignored.
      var label = btn.querySelector('span'), text = label.textContent;
      btn.setAttribute('aria-busy', 'true'); label.textContent = 'LOADING…';
      setTimeout(function () {
        var from = shown; shown += per; paint(from);
        btn.removeAttribute('aria-busy'); label.textContent = text;
      }, 350);
    });
    // Cards are rendered newest-first; the two sort options are each other's reverse.
    if (sel) sel.addEventListener('change', function () {
      Array.prototype.slice.call(grid.children).reverse().forEach(function (c) { grid.appendChild(c); c.classList.remove('is-new'); });
      shown = per;
      paint();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    var page = document.querySelector('[data-cart-page-items]');
    if (!page) return;
    function change(line, qty) {
      page.style.opacity = '0.5';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function () { window.location.reload(); });
    }
    page.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cart-remove]');
      if (!t) return;
      e.preventDefault();
      change(parseInt(t.getAttribute('data-line'), 10), 0);
    });
    page.addEventListener('change', function (e) {
      var t = e.target.closest('[data-cart-qty-input]');
      if (!t) return;
      change(parseInt(t.getAttribute('data-line'), 10), Math.max(0, parseInt(t.value, 10) || 0));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-zk-col]').forEach(function (root) {
    var sectionId = root.getAttribute('data-section-id');

    // Everything inside the rail/content is re-rendered on filter, so all handlers are delegated to the root.
    root.addEventListener('click', function (e) {
      var acc = e.target.closest('.zk-col__acc-summary');
      if (acc) {
        var box = acc.parentElement, open = box.classList.toggle('is-open');
        acc.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      var toggle = e.target.closest('[data-col-toggle]');
      if (toggle) {
        var on = root.classList.toggle('is-filters-open');
        toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
        return;
      }
      var next = e.target.closest('[data-col-next]');
      if (next) { e.preventDefault(); loadMore(next); return; }
      // Filter values, active chips, Clear all, category chips → fetch instead of navigating
      var link = e.target.closest('.zk-col__value, .zk-col__chip, .zk-col__clear, .zk-col__cat');
      if (link && link.href) { e.preventDefault(); load(link.href, true); }
    });
    root.addEventListener('change', function (e) {
      var sort = e.target.closest('[data-sort-select]');
      if (sort) load(formUrl(sort.form), true);
    });
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('.zk-col__price, .zk-col__sort');
      if (form) { e.preventDefault(); load(formUrl(form), true); }
    });
    function formUrl(form) {
      var u = new URL(form.getAttribute('action') || location.pathname, location.origin);
      // append, not set: a category chip = several values under one filter param name
      new FormData(form).forEach(function (v, k) { if (v !== '') u.searchParams.append(k, v); });
      return u.href;
    }

    var pending = 0;
    function fetchSection(url) {
      var u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
      return fetch(u.href).then(function (r) { return r.text(); }).then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
    }

    // Re-render rail + content in place; keep which accordions the user had open and the
    // mobile panel state (the class lives on the root, which is never replaced).
    function load(url, push) {
      var seq = ++pending;
      var railInner = root.querySelector('.zk-col__rail-inner');
      var content = root.querySelector('.zk-col__content');
      var openLabels = Array.prototype.map.call(root.querySelectorAll('.zk-col__accordion.is-open .zk-col__acc-title'), function (t) { return t.textContent.trim(); });
      root.classList.add('is-loading');
      fetchSection(url).then(function (doc) {
        if (seq !== pending) return;
        var freshRail = doc.querySelector('.zk-col__rail-inner');
        var freshContent = doc.querySelector('.zk-col__content');
        if (freshRail && railInner) railInner.innerHTML = freshRail.innerHTML;
        if (freshContent && content) content.innerHTML = freshContent.innerHTML;
        root.querySelectorAll('.zk-col__accordion').forEach(function (acc) {
          var label = acc.querySelector('.zk-col__acc-title').textContent.trim();
          if (openLabels.indexOf(label) > -1) {
            acc.classList.add('is-open');
            acc.querySelector('.zk-col__acc-summary').setAttribute('aria-expanded', 'true');
          }
        });
        var t = root.querySelector('[data-col-toggle]');
        if (t) t.setAttribute('aria-expanded', root.classList.contains('is-filters-open') ? 'true' : 'false');
        if (push && history.pushState) history.pushState({ zkCol: true }, '', url);
        if (window.zkInitSwapped) window.zkInitSwapped(root);
      }).catch(function () {}).then(function () { if (seq === pending) root.classList.remove('is-loading'); });
    }
    window.addEventListener('popstate', function () { load(location.href, false); });

    // LOAD MORE: append the next page's cards
    function loadMore(btn) {
      var grid = root.querySelector('[data-col-grid]');
      var more = root.querySelector('[data-col-more]');
      btn.classList.add('is-loading');
      fetchSection(btn.href).then(function (doc) {
        var freshGrid = doc.querySelector('[data-col-grid]');
        if (freshGrid && grid) Array.prototype.slice.call(freshGrid.children).forEach(function (c) { grid.appendChild(c); });
        var freshNext = doc.querySelector('[data-col-next]');
        if (freshNext) { btn.href = freshNext.getAttribute('href'); btn.classList.remove('is-loading'); }
        else if (more) more.remove();
      }).catch(function () { btn.classList.remove('is-loading'); });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-collist]').forEach(function (root) {
    var grid = root.querySelector('[data-collist-grid]');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.zk-collist__item'));
    var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 8;
    var shown = pageSize;
    var sort = root.querySelector('[data-collist-sort]');
    var more = root.querySelector('[data-collist-more]');

    function order(mode) {
      var by = mode.indexOf('title') === 0 ? 'title' : 'id';
      var dir = mode.indexOf('-asc') > -1 ? 1 : -1;
      return items.slice().sort(function (a, b) {
        if (by === 'title') return dir * a.dataset.title.localeCompare(b.dataset.title, undefined, { sensitivity: 'base' });
        return dir * (Number(a.dataset.id) - Number(b.dataset.id)); // ponytail: collection id as creation order; use a date metafield if ids ever stop being monotonic
      });
    }
    function render() {
      var list = order(sort ? sort.value : 'date-desc');
      list.forEach(function (el, i) { grid.appendChild(el); el.hidden = i >= shown; });
      if (more) more.parentElement.hidden = shown >= list.length;
    }
    if (sort) sort.addEventListener('change', function () { shown = pageSize; render(); });
    if (more) more.addEventListener('click', function () { shown += pageSize; render(); });
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  // Variant switcher: keeps both selects in sync, updates price / stock / ADD TO BAG,
  // swaps the vertical profile image and jumps the gallery to the variant's media.
  document.querySelectorAll('[data-zk-product]').forEach(function (top) {
    var root = top.closest('.zk-mp');
    var dataEl = root.querySelector('[data-zk-variants]');
    if (!dataEl) return;
    var variants = []; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = root.querySelectorAll('[data-zk-variant-select]');
    var track = root.querySelector('[data-gallery-track]');
    function apply(id) {
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      selects.forEach(function (sel) { if (sel.value !== String(id)) sel.value = String(id); });
      root.querySelectorAll('[data-zk-bar-id]').forEach(function (input) { input.value = id; });
      root.querySelectorAll('[data-zk-price]').forEach(function (price) { price.textContent = v.price; });
      var skuEl = root.querySelector('[data-zk-sku]');
      if (skuEl && v.sku) skuEl.textContent = v.sku;
      var stock = root.querySelector('[data-zk-stock]');
      if (stock) {
        stock.innerHTML = '<span class="zk-mp-buy__dot' + (v.available ? '' : ' is-off') + '" aria-hidden="true"></span>' +
          (v.available ? '<span class="zk-mp-buy__stock">In Stock</span><span class="zk-mp-buy__stock zk-mp-buy__sep">/</span><span class="zk-mp-buy__stock">Ready to Ship</span>' : '<span class="zk-mp-buy__stock">Sold out</span>');
      }
      root.querySelectorAll('[data-zk-atb]').forEach(function (b) {
        b.disabled = !v.available;
        var l = b.querySelector('[data-zk-atb-label]'); if (l) l.textContent = v.available ? 'ADD TO BAG' : 'SOLD OUT';
      });
      if (track && v.featured_media_id) {
        var slide = track.querySelector('[data-media-id="' + v.featured_media_id + '"]');
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      var u = new URL(location.href); u.searchParams.set('variant', id);
      if (history.replaceState) history.replaceState(null, '', u);
      // Everything metafield-driven (profile image, breadcrumb, spec table, editorial,
      // Why Choose, Care) is server-rendered per variant → fetch the page and swap regions.
      var seq = ++pending;
      fetch(u.href, { headers: { 'X-Requested-With': 'fetch' } }).then(function (r) { return r.text(); }).then(function (html) {
        if (seq !== pending) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        document.querySelectorAll('[data-zk-swap]').forEach(function (cur) {
          var key = cur.getAttribute('data-zk-swap');
          var fresh = doc.querySelector('[data-zk-swap="' + key + '"]');
          if (!fresh) return;
          cur.innerHTML = fresh.innerHTML;
          cur.hidden = fresh.hidden;
          if (window.zkInitSwapped) window.zkInitSwapped(cur);
        });
        var freshTop = doc.querySelector('[data-zk-product]');
        if (freshTop) top.className = freshTop.className;
      }).catch(function () {});
    }
    var pending = 0;
    selects.forEach(function (sel) { sel.addEventListener('change', function () { apply(sel.value); }); });
  });

  document.querySelectorAll('.zk-mp [data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-gallery-track]');
    var slides = g.querySelectorAll('[data-gallery-slide]');
    // Looping prev/next: assets/gallery.js (loaded at the end of <body>, after this bundle)
    if (window.zkGallery) window.zkGallery(g);
    else document.addEventListener('DOMContentLoaded', function () { if (window.zkGallery) window.zkGallery(g); });

    // Click zoom — desktop pointer devices only
    var canZoom = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches;
    if (!canZoom) return;
    slides.forEach(function (slide) {
      var img = slide.querySelector('.zk-mp-gallery__img');
      var src = slide.dataset.zoomSrc;
      if (!img) return;
      var primed = false;
      function prime() {
        // Swap in the 2400px source once so the zoomed view stays sharp
        if (primed || !src) return; primed = true;
        var hi = new Image();
        hi.onload = function () { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; };
        hi.src = src;
      }
      function origin(e) {
        var r = slide.getBoundingClientRect();
        var x = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100));
        var y = Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100));
        img.style.transformOrigin = x + '% ' + y + '%';
      }
      // Hover only preloads the sharp source so the first click zooms without a soft frame
      slide.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') prime(); });
      slide.addEventListener('click', function (e) {
        prime();
        origin(e);
        slide.classList.toggle('is-zooming');
      });
      slide.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'mouse' && slide.classList.contains('is-zooming')) origin(e);
      });
      slide.addEventListener('pointerleave', function () { slide.classList.remove('is-zooming'); });
    });
    function unzoom() { slides.forEach(function (s) { s.classList.remove('is-zooming'); }); }
    // Reset while the track scrolls between slides, and on Escape
    track.addEventListener('scroll', unzoom, { passive: true });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') unzoom(); });
  });

  // Compact section nav. Hidden until the page scrolls, then it replaces the breadcrumb row.
  (function () {
    var bar = document.querySelector('[data-zk-pdp-bar]');
    var nav = document.querySelector('[data-zk-pdp-nav]');
    if (!bar || !nav || nav.dataset.ready) return;
    nav.dataset.ready = '1';
    var list = nav.querySelector('[data-zk-pdp-nav-list]');
    var crumbs = bar.querySelector('.zk-mp-crumbs');
    function liveSections() {
      return Array.prototype.filter.call(document.querySelectorAll('[data-zk-pdp-section]'), function (section) {
        return section.id && !section.hidden && section.getAttribute('data-zk-pdp-label');
      });
    }
    var sections = liveSections();
    if (sections.length < 2) return;
    sections.forEach(function (section) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + section.id;
      link.textContent = section.getAttribute('data-zk-pdp-label');
      item.appendChild(link);
      list.appendChild(item);
    });
    var links = list.querySelectorAll('a');
    var mark = document.createElement('span');
    mark.className = 'zk-pdp-nav__mark';
    mark.setAttribute('aria-hidden', 'true');
    list.appendChild(mark);
    function headerHeight() {
      var header = document.querySelector('.zk-header');
      return header ? header.offsetHeight : 80;
    }
    function moveMark(link) {
      var item = link.parentElement;
      mark.style.width = item.offsetWidth + 'px';
      mark.style.transform = 'translateX(' + item.offsetLeft + 'px)';
      var viewLeft = list.scrollLeft;
      var viewRight = viewLeft + list.clientWidth;
      if (item.offsetLeft < viewLeft || item.offsetLeft + item.offsetWidth > viewRight) {
        var edge = item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        list.scrollTo({ left: Math.max(0, edge), behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    function setActive(id) {
      var active = null;
      links.forEach(function (link) {
        var on = link.getAttribute('href') === '#' + id;
        link.classList.toggle('is-active', on);
        if (on) {
          link.setAttribute('aria-current', 'location');
          active = link;
        } else {
          link.removeAttribute('aria-current');
        }
      });
      if (active) moveMark(active);
    }
    function sectionInView() {
      var current = liveSections();
      var line = headerHeight() + (nav.classList.contains('is-in') ? nav.offsetHeight : 0) + 24;
      var id = current[0] ? current[0].id : '';
      current.forEach(function (section) {
        if (section.getBoundingClientRect().top <= line) id = section.id;
        var link = list.querySelector('a[href="#' + section.id + '"]');
        if (link) link.textContent = section.getAttribute('data-zk-pdp-label');
      });
      return id;
    }
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href').slice(1);
        var section = document.getElementById(id);
        if (!section) return;
        event.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        section.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.pushState) history.pushState(null, '', '#' + id);
      });
    });
    var frame = 0;
    var hero = document.getElementById('zk-pdp-details');
    var buy = document.querySelector('[data-zk-pdp-buybar]');
    function place() {
      var top = headerHeight();
      bar.style.setProperty('--zk-pdp-bar-top', top + 'px');
      var pastCrumbs = crumbs ? crumbs.getBoundingClientRect().bottom <= top + 1 : window.scrollY > 8;
      nav.classList.toggle('is-in', pastCrumbs);
      if (pastCrumbs) setActive(sectionInView());
      var pastHero = hero ? hero.getBoundingClientRect().bottom <= top + 1 : pastCrumbs;
      if (buy) {
        buy.classList.toggle('is-in', pastHero);
        buy.setAttribute('aria-hidden', pastHero ? 'false' : 'true');
        document.documentElement.style.setProperty('--zk-pdp-buybar-space', pastHero ? buy.offsetHeight + 'px' : '0px');
      }
    }
    window.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () { frame = 0; place(); });
    }, { passive: true });
    window.addEventListener('resize', place);
    place();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.zk-search').forEach(function (root) {
      root.classList.add('is-js');
      root.addEventListener('click', function (e) {
        var link = e.target.closest('[data-search-next]');
        if (!link) return;
        e.preventDefault();
        link.setAttribute('aria-busy', 'true');
        fetch(link.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var grid = root.querySelector('[data-search-grid]');
            var incoming = doc.querySelector('[data-search-grid]');
            if (grid && incoming) {
              while (incoming.firstElementChild) grid.appendChild(incoming.firstElementChild);
            }
            var nextLink = doc.querySelector('[data-search-next]');
            var wrap = link.closest('.zk-search__more');
            if (nextLink) { link.href = nextLink.getAttribute('href'); link.removeAttribute('aria-busy'); }
            else if (wrap) { wrap.remove(); }
          })
          .catch(function () { link.removeAttribute('aria-busy'); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    function init(root) {
      var KEY = 'zk-popup-' + root.id;
      var card = root.querySelector('.zk-pop__card');
      var success = root.querySelector('[data-zk-success]');
      var dismissed = false;
      try { dismissed = localStorage.getItem(KEY) === '1'; } catch (e) {}

      // If the form just posted successfully, show immediately (Shopify reloads with anchor).
      if (success) {
        open();
      } else if (!dismissed) {
        var delay = parseInt(root.dataset.delay, 10) || 5000;
        // Wait for a first interaction so the popup never interrupts the initial load
        // (and never fires in a non-interacting audit run); then honour the delay.
        var armed = false;
        function arm() {
          if (armed) return; armed = true;
          ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (n) { window.removeEventListener(n, arm); });
          setTimeout(open, delay);
        }
        ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (n) { window.addEventListener(n, arm, { passive: true }); });
      }

      function persist() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }

      function open() {
        root.hidden = false;
        document.addEventListener('keydown', onKey);
        var first = root.querySelector('.zk-pop__input, .zk-pop__close');
        if (first) { first.focus(); }
      }
      function close() {
        document.removeEventListener('keydown', onKey);
        persist();
        // Animate out, then remove from layout.
        root.classList.add('is-closing');
        setTimeout(function () { root.hidden = true; root.classList.remove('is-closing'); }, 260);
      }
      function onKey(e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') { return; }
        var f = root.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
        if (!f.length) { return; }
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }

      root.querySelectorAll('[data-zk-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
    }
    document.querySelectorAll('[data-zk-popup]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"] && !Shopify.designMode) return;
  try {
    
  const MAX_FILES = 5;
  const MAX_SIZE = 5 * 1024 * 1024;

  document.querySelectorAll('[data-zk-support]').forEach((form) => {
    const status = form.querySelector('.zk-help__status');
    const button = form.querySelector('[type=submit]');
    const show = (text, isError) => {
      status.textContent = text;
      status.className = 'zk-help__status ' + (isError ? 'zk-help__error' : 'zk-help__success');
      status.hidden = false;
      status.scrollIntoView({ block: 'nearest' });
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const data = new FormData(form);
      if (data.get('website')) { form.reset(); show(form.dataset.success.replace('{id}', '0'), false); return; }

      const files = data.getAll('files').filter((f) => f.size > 0);
      if (files.length > MAX_FILES) return show(`Maximum of ${MAX_FILES} files allowed`, true);
      if (files.some((f) => f.size > MAX_SIZE)) return show('File size is too large (max 5MB per file)', true);

      button.disabled = true;
      status.hidden = true;
      try {
        const res = await fetch(form.dataset.api, { method: 'POST', body: data });
        const json = await res.json();
        if (!res.ok) throw new Error(json.error || `Request failed (${res.status})`);
        form.reset();
        const id = json.id;
        show(id ? form.dataset.success.replace("{id}", id) : form.dataset.success.replace(/\s*\(ticket id: \{id\}\)/, ""), false);
      } catch (err) {
        show(err.message || 'Something went wrong, please try again.', true);
      } finally {
        if (window.turnstile) window.turnstile.reset(form.querySelector('.cf-turnstile'));
        button.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
  // <details> snaps open/closed; animate the answer's height + opacity around it (same approach as product-faq).
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
    document.querySelectorAll('.zk-help__item').forEach(function (d) {
      var q = d.querySelector('.zk-help__q'), a = d.querySelector('.zk-help__a');
      if (!q || !a) return;
      q.addEventListener('click', function (e) {
        e.preventDefault();
        if (reduce || !a.animate) { d.open = !d.open; return; }
        if (d.dataset.animating) return;
        d.dataset.animating = '1';
        if (!d.open) {
          d.open = true;
          a.animate([{ height: '0px', opacity: 0, paddingBottom: '0px' }, { height: a.scrollHeight + 'px', opacity: 1 }], { duration: 320, easing: EASE })
            .finished.then(function () { delete d.dataset.animating; });
        } else {
          a.animate([{ height: a.getBoundingClientRect().height + 'px', opacity: 1 }, { height: '0px', opacity: 0, paddingBottom: '0px' }], { duration: 240, easing: 'ease-in' })
            .finished.then(function () { d.open = false; delete d.dataset.animating; });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DUR = 320, EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

    // <details> snaps open/closed; animate the answer's height + opacity around it.
    function setOpen(details, open) {
      var body = details.querySelector('.zk-faq__a');
      if (!body || details.open === open) return Promise.resolve();
      if (reduce || !body.animate) { details.open = open; return Promise.resolve(); }
      if (details.dataset.animating) return Promise.resolve();
      details.dataset.animating = '1';
      if (open) {
        details.open = true;
        var h = body.scrollHeight;
        var a = body.animate(
          [{ height: '0px', opacity: 0, marginTop: '0px' }, { height: h + 'px', opacity: 1, marginTop: '' }],
          { duration: DUR, easing: EASE }
        );
        return a.finished.then(function () { delete details.dataset.animating; });
      }
      var h0 = body.getBoundingClientRect().height;
      var b = body.animate(
        [{ height: h0 + 'px', opacity: 1 }, { height: '0px', opacity: 0, marginTop: '0px' }],
        { duration: DUR * 0.8, easing: 'ease-in' }
      );
      return b.finished.then(function () { details.open = false; delete details.dataset.animating; });
    }

    document.querySelectorAll('[data-zk-faq]').forEach(function (faq) {
      var items = faq.querySelectorAll('.zk-faq__item');
      var btn = faq.querySelector('[data-faq-toggle]');
      var label = btn && btn.querySelector('[data-faq-label]');
      function sync() {
        var anyOpen = Array.prototype.some.call(items, function (d) { return d.open; });
        if (btn) btn.setAttribute('aria-expanded', anyOpen ? 'true' : 'false');
        if (label) label.textContent = anyOpen ? 'COLLAPSE ALL' : 'EXPAND ALL';
      }
      items.forEach(function (d) {
        var q = d.querySelector('.zk-faq__q');
        q.addEventListener('click', function (e) {
          e.preventDefault();
          setOpen(d, !d.open).then(sync);
        });
      });
      if (btn) btn.addEventListener('click', function () {
        var anyOpen = Array.prototype.some.call(items, function (d) { return d.open; });
        var ps = Array.prototype.map.call(items, function (d, i) {
          // light stagger so the grid folds/unfolds as a wave
          return new Promise(function (r) { setTimeout(function () { setOpen(d, !anyOpen).then(r); }, reduce ? 0 : i * 40); });
        });
        Promise.all(ps).then(sync);
        // reflect the target state immediately on the button
        if (btn) btn.setAttribute('aria-expanded', anyOpen ? 'false' : 'true');
        if (label) label.textContent = anyOpen ? 'EXPAND ALL' : 'COLLAPSE ALL';
      });
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function carousel(rel) {
      var track = rel.querySelector('[data-rel-track]');
      if (!track) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var step = function () {
        var slide = track.querySelector('.zk-rel__slide');
        var gap = parseInt(getComputedStyle(track).columnGap, 10) || 48;
        return slide ? slide.offsetWidth + gap : track.clientWidth;
      };
      var prev = rel.querySelector('[data-rel-prev]');
      var next = rel.querySelector('[data-rel-next]');
      function update() {
        var hasLeft = track.scrollLeft > 1;
        var hasRight = track.scrollLeft + track.clientWidth < track.scrollWidth - 1;
        var shell = track.parentElement;
        if (shell && shell.classList.contains('zk-rel__shell')) {
          shell.classList.toggle('has-left-fade', hasLeft);
          shell.classList.toggle('has-right-fade', hasRight);
        }
        if (!prev || !next) return;
        prev.disabled = !hasLeft;
        next.disabled = !hasRight;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      update();

      // Mouse drag to scroll (touch already scrolls natively)
      var down = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        // Only becomes a drag after 4px: a plain click keeps pointer-events on the cards
        if (Math.abs(dx) > 4 && !moved) { moved = true; track.classList.add('is-dragging'); }
        if (moved) track.scrollLeft = startLeft - dx;
      });
      function endDrag() { down = false; track.classList.remove('is-dragging'); }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    }

    document.querySelectorAll('[data-rel-recommendations]').forEach(function (rel) {
      var url = rel.getAttribute('data-url');
      // Already populated (e.g. design-mode placeholders or server-rendered) → just wire carousel.
      if (rel.querySelector('[data-rel-track]')) { carousel(rel); return; }
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var html = new DOMParser().parseFromString(text, 'text/html');
          var fresh = html.querySelector('[data-rel-recommendations]');
          if (fresh) { rel.innerHTML = fresh.innerHTML; carousel(rel); }
        })
        .catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urgent-message"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 460;
    var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

    function init(root) {
      var bar = root.querySelector('[data-zk-urgent-bar]');
      var fab = root.querySelector('[data-zk-urgent-fab]');
      if (!bar || !fab) return;
      var campaign = root.getAttribute('data-campaign') || 'we-built-zaku';
      var key = 'zk-urgent:' + campaign;
      var busy = false;
      var token = 0;
      function remember(collapsed) {
        try {
          if (collapsed) localStorage.setItem(key, 'collapsed');
          else localStorage.removeItem(key);
        } catch (e) {}
      }

      function lift() {
        var cookie = document.querySelector('[data-zk-cookie]');
        var cookieH = cookie && !cookie.hidden ? cookie.offsetHeight : 0;
        var buy = document.querySelector('[data-zk-pdp-buybar]');
        var buyH = buy && buy.classList.contains('is-in') ? buy.offsetHeight : 0;
        return Math.max(cookieH, buyH);
      }
      function pin() {
        bar.style.setProperty('--zk-urgent-lift', lift() + 'px');
      }
      function reduced() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
      function release(id) {
        if (id !== token) return;
        bar.style.width = '';
        bar.style.height = '';
        bar.style.transition = '';
        busy = false;
      }
      function morph(collapsed) {
        var current = bar.classList.contains('is-collapsed');
        if (current === collapsed && !bar.style.width) return;
        if (reduced()) {
          bar.classList.toggle('is-collapsed', collapsed);
          fab.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          bar.style.width = '';
          bar.style.height = '';
          bar.style.transition = '';
          return;
        }
        var id = ++token;
        busy = true;
        var startW = bar.offsetWidth;
        var startH = bar.offsetHeight;
        bar.style.transition = 'none';
        bar.classList.toggle('is-collapsed', collapsed);
        bar.style.width = '';
        bar.style.height = '';
        var endW = bar.offsetWidth;
        var endH = bar.offsetHeight;
        bar.classList.toggle('is-collapsed', !collapsed);
        bar.style.width = startW + 'px';
        bar.style.height = startH + 'px';
        bar.offsetWidth;
        bar.style.transition = 'width ' + DURATION + 'ms ' + EASE + ', height ' + DURATION + 'ms ' + EASE + ', padding ' + DURATION + 'ms ' + EASE + ', background-color ' + DURATION + 'ms ease, color ' + DURATION + 'ms ease, border-color ' + DURATION + 'ms ease, bottom 0.4s ' + EASE;
        bar.classList.toggle('is-collapsed', collapsed);
        fab.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        bar.style.width = endW + 'px';
        bar.style.height = endH + 'px';
        setTimeout(function () { release(id); }, DURATION + 40);
      }

      pin();

      var cookie = document.querySelector('[data-zk-cookie]');
      if (cookie && window.MutationObserver) {
        new MutationObserver(pin).observe(cookie, { attributes: true, attributeFilter: ['hidden', 'class'] });
      }
      var buy = document.querySelector('[data-zk-pdp-buybar]');
      if (buy && window.ResizeObserver) new ResizeObserver(function () { if (!busy) pin(); }).observe(buy);
      if (buy && window.MutationObserver) {
        new MutationObserver(function () { if (!busy) pin(); }).observe(buy, { attributes: true, attributeFilter: ['class'] });
      }
      window.addEventListener('resize', function () {
        if (busy) return;
        pin();
      });

      var dismiss = bar.querySelector('[data-zk-urgent-dismiss]');
      if (!dismiss) return;
      dismiss.addEventListener('click', function (event) {
        event.stopPropagation();
        remember(true);
        morph(true);
      });
      bar.addEventListener('click', function (event) {
        if (!bar.classList.contains('is-collapsed')) return;
        if (event.target.closest('[data-zk-urgent-dismiss]')) return;
        remember(false);
        morph(false);
      });
    }
    document.querySelectorAll('.zk-urgent-fab-root[data-zk-urgent]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();
})();
